/* =============================================================
   ST category chips without page reload (Wrike 4584025633, Ali 14.10.2026).
   A chip click swaps the product list in place and updates the URL with
   pushState; Back/Forward render the same way. Chips stay real links:
   with modifier keys, in the theme editor or without JS the browser
   follows them.

   Round 5 (Argus 2 for Ali 19.10.2026, "must feel like an in-page filter"):
   - One small Section Rendering request per target (?sections=<main-collection>,<hero>),
     not the whole page. main-collection brings grid, count, chips, filters,
     sort, pagination and the compare box; it is swapped as one section.
   - The hero (first section) is updated as text only when the target hero
     differs in nothing but its text slots (data-st-text: K5 title/intro,
     hero heading/subheading/text blocks), so the compact head keeps its
     height and its video keeps playing. Otherwise it is swapped whole.
   - The chip row is kept at the same position on screen (scroll anchoring).
   - Prefetch on touchstart / hover / focus, responses cached per URL.
   - Other sections that depend on the collection (banner, FAQ ...) are
     refreshed after the swap, one request per 5 sections, and only when
     their server HTML differs from the one of the previous URL.
   - Every fallback to a normal page load is logged with its reason:
     console, dataLayer (event st_chip_fallback), window.stChipsNav.fallbacks
     and sessionStorage "stChipsFallbacks" (survives the reload, for QA).
   - API for other scripts (PR #219, assets/st-category-chips.js):
     window.stChipsNav.go(url, push) and .prefetch(url). After a swap the
     event "st:chips:navigate" fires; listeners may pass a promise to
     event.detail.waitUntil() (e.g. rows that narrow the grid), the grid
     stays marked busy until it settles and the row is anchored again.
     Chip views (?st_view / ?st_chip) are fetched without those params.
   While assets/st-category-chips.js (PR #219) is on the page, it receives
   the chip taps (it opens the subcategory rows) and hands the page switch
   to window.stChipsNav.go, so the result is the same. Phones only until
   2026-10-25, every width since (Wrike 4591276398, rows on desktop).
   Markup: snippets/st-category-chips.liquid. Rollback: remove the script
   tag there; the chips are plain links and work without this file.
   ============================================================= */
(function () {
  if (window.stChipsNav) return;

  var SECTIONS = "#MainContent > .shopify-section";
  var TIMEOUT = 10000;
  var IMAGE_WAIT = 800; // ms the old grid waits at most for the new images in view
  var SETTLE_WAIT = 1500; // ms the grid stays busy at most for waitUntil() promises
  var CACHE_MAX = 16;
  var cache = new Map(); // "<key>|<section ids>" -> promise of the Section Rendering JSON
  var current = location.pathname + location.search; // content on screen
  var pushed = false;
  var job = null;
  var fallbacks = [];

  function grid(root) {
    var el = (root || document).querySelector("#ProductGridContainer");
    return el && el.closest(".shopify-section");
  }

  function sid(el) {
    return el.id.replace(/^shopify-section-/, "");
  }

  function hero() {
    var first = document.querySelector(SECTIONS);
    return first && first !== grid() ? first : null;
  }

  function others() {
    var main = grid();
    var head = hero();
    return Array.prototype.filter.call(
      document.querySelectorAll(SECTIONS),
      function (el) {
        return el !== main && el !== head;
      },
    );
  }

  // Page address without what only the browser uses (chip view of PR #219, hash) or what we add.
  function pageKey(url) {
    var u = new URL(url, location.href);
    ["st_view", "st_chip", "sections", "section_id"].forEach(function (p) {
      u.searchParams.delete(p);
    });
    return u.pathname + u.search;
  }

  function failure(reason) {
    var err = new Error(reason);
    err.reason = reason;
    return err;
  }

  function sections(url, ids) {
    var key = pageKey(url) + "|" + ids.join(",");
    if (cache.has(key)) return cache.get(key);
    var u = new URL(pageKey(url), location.href);
    u.searchParams.set("sections", ids.join(","));
    var request = fetch(u.pathname + u.search, { credentials: "same-origin" })
      .then(function (res) {
        if (res.redirected) throw failure("redirect");
        if (!res.ok) throw failure("http-" + res.status);
        return res.json();
      })
      .catch(function (err) {
        throw err.reason ? err : failure("network");
      });
    cache.set(key, request);
    request.catch(function () {
      cache.delete(key);
    });
    if (cache.size > CACHE_MAX) cache.delete(cache.keys().next().value);
    return request;
  }

  // Grid + hero of a page: the one request a chip switch waits for.
  function mainIds() {
    var main = grid();
    if (!main) return null;
    var head = hero();
    return head ? [sid(main), sid(head)] : [sid(main)];
  }

  function prefetch(url) {
    var ids = mainIds();
    if (!ids) return;
    sections(url, ids).catch(function () {});
    // Server HTML of the hero on screen: tells a text-only hero change from a real one.
    if (ids[1]) sections(current, [ids[1]]).catch(function () {});
  }

  function parse(html, id) {
    if (!html) return null;
    var doc = new DOMParser().parseFromString(html, "text/html");
    return doc.getElementById("shopify-section-" + id);
  }

  // Server HTML of a section without what differs per request or per render mode: app blocks (random order),
  // image loading hints; with texts = true also without the text slots (data-st-text).
  function fingerprint(el, texts) {
    var copy = el.cloneNode(true);
    copy.querySelectorAll(".shopify-app-block").forEach(function (b) {
      b.remove();
    });
    copy
      .querySelectorAll("[loading], [fetchpriority], [decoding]")
      .forEach(function (n) {
        n.removeAttribute("loading");
        n.removeAttribute("fetchpriority");
        n.removeAttribute("decoding");
      });
    if (texts)
      copy.querySelectorAll("[data-st-text]").forEach(function (n) {
        n.textContent = "";
      });
    return el.className + "|" + copy.innerHTML;
  }

  function loadedScripts() {
    var set = {};
    Array.prototype.forEach.call(document.scripts, function (s) {
      if (s.src) set[s.src] = true;
    });
    return set;
  }

  // innerHTML leaves scripts inert: re-create inline ones and files not loaded yet.
  function runScripts(container, loaded) {
    container.querySelectorAll("script").forEach(function (old) {
      var type = old.getAttribute("type");
      if (type && type !== "text/javascript" && type !== "module") return;
      if (old.src && loaded[old.src]) return;
      var fresh = document.createElement("script");
      Array.prototype.forEach.call(old.attributes, function (a) {
        fresh.setAttribute(a.name, a.value);
      });
      fresh.textContent = old.textContent;
      old.replaceWith(fresh);
    });
  }

  function whenDone(promises, ms) {
    return Promise.race([
      Promise.all(
        promises.map(function (p) {
          return Promise.resolve(p).catch(function () {});
        }),
      ),
      new Promise(function (resolve) {
        setTimeout(resolve, ms);
      }),
    ]);
  }

  // A stylesheet <link> re-inserted with new HTML applies a few frames late (unstyled flash):
  // keep one applied copy in <head> instead and drop the links from the new HTML.
  function keepStyles(box, swapped) {
    var waits = [];
    box.querySelectorAll('link[rel="stylesheet"]').forEach(function (link) {
      var href = link.href;
      link.remove();
      if (!href) return;
      var kept = Array.prototype.some.call(
        document.querySelectorAll('link[rel="stylesheet"]'),
        function (el) {
          return (
            el.href === href && el.media !== "print" && !swapped.contains(el)
          );
        },
      );
      if (kept) return;
      var copy = document.createElement("link");
      copy.rel = "stylesheet";
      copy.href = href;
      waits.push(
        new Promise(function (resolve) {
          copy.onload = copy.onerror = resolve;
        }),
      );
      document.head.appendChild(copy);
    });
    return waits;
  }

  // Lazy images start invisible (vendor.js lazy-image) until loaded: load and decode the cards that will be
  // in view while the old grid is still shown.
  function preloadCards(box) {
    var n = 0;
    document
      .querySelectorAll("#ProductGridContainer .card")
      .forEach(function (card) {
        var r = card.getBoundingClientRect();
        if (r.bottom > 0 && r.top < window.innerHeight) n++;
      });
    var count = Math.min(Math.max(n, 4) + 4, 16);
    var imgs = [];
    Array.prototype.slice
      .call(box.querySelectorAll("#ProductGridContainer .card"), 0, count)
      .forEach(function (card) {
        imgs = imgs.concat(
          Array.prototype.slice.call(card.querySelectorAll(".media img")),
        );
      });
    return imgs.map(function (img) {
      if (img.getAttribute("loading") === "lazy")
        img.setAttribute("loading", "eager");
      if (img.decode) return img.decode();
      return new Promise(function (resolve) {
        img.onload = img.onerror = resolve;
      });
    });
  }

  function swapSection(prev, fresh, loaded) {
    var box = document.createElement("div");
    box.innerHTML = fresh.innerHTML;
    keepStyles(box, prev);
    prev.className = fresh.className;
    prev.replaceChildren.apply(
      prev,
      Array.prototype.slice.call(box.childNodes),
    );
    runScripts(prev, loaded);
  }

  // Hero: text slots only when nothing else differs (same media, same layout), else the whole section.
  function updateHero(prev, fresh, before, loaded) {
    if (before && fingerprint(before, false) === fingerprint(fresh, false))
      return "same";
    if (before && fingerprint(before, true) === fingerprint(fresh, true)) {
      var ok = true;
      var slots = [];
      fresh.querySelectorAll("[data-st-text]").forEach(function (next) {
        var key = next.getAttribute("data-st-text");
        var now = prev.querySelectorAll('[data-st-text="' + key + '"]');
        if (!now.length) ok = false;
        slots.push([now, next]);
      });
      if (ok) {
        slots.forEach(function (pair) {
          pair[0].forEach(function (el) {
            if (el.innerHTML !== pair[1].innerHTML)
              el.innerHTML = pair[1].innerHTML;
          });
        });
        return "text";
      }
    }
    swapSection(prev, fresh, loaded);
    return "full";
  }

  // Title, description and canonical of the target: snippets/st-category-chips.liquid writes them into the
  // section as JSON, because a Section Rendering response has no <head>.
  function syncHead(section, url) {
    var data = section.querySelector("script[data-st-chips-head]");
    if (data) {
      try {
        var head = JSON.parse(data.textContent);
        // page_title / page_description arrive HTML-escaped (&amp;).
        var plain = document.createElement("textarea");
        ["title", "description"].forEach(function (k) {
          plain.innerHTML = head[k] || "";
          head[k] = plain.value;
        });
        if (head.title) document.title = head.title;
        var desc = document.head.querySelector('meta[name="description"]');
        if (desc && head.description)
          desc.setAttribute("content", head.description);
        var canonical = document.head.querySelector('link[rel="canonical"]');
        if (canonical && head.canonical)
          canonical.setAttribute("href", head.canonical);
        var ogUrl = document.head.querySelector('meta[property="og:url"]');
        if (ogUrl && head.canonical)
          ogUrl.setAttribute("content", head.canonical);
      } catch (e) {
        /* keep the old head */
      }
    }
    // Country/language switch returns to the page that is shown now.
    var path = new URL(url, location.href).pathname;
    document
      .querySelectorAll('form[action*="/localization"] input[name="return_to"]')
      .forEach(function (input) {
        input.value = path;
      });
  }

  function rowTop() {
    var el =
      document.querySelector("#MainContent .st-chips") ||
      document.querySelector("#MainContent .collection__topbar");
    return el ? el.getBoundingClientRect().top : null;
  }

  function anchor(top) {
    var now = rowTop();
    if (top === null || now === null) return;
    if (Math.abs(now - top) > 0.5) window.scrollBy(0, now - top);
  }

  function keepRowScroll(left, group) {
    var row = document.querySelector("#MainContent .st-chips");
    if (!row) return;
    if (row.dataset.stGroup === group) row.scrollLeft = left;
    var active = row.querySelector(".st-chip.is-active");
    if (!active) return;
    var a = active.getBoundingClientRect();
    var r = row.getBoundingClientRect();
    if (a.left < r.left || a.right > r.right)
      row.scrollLeft += a.left - r.left - 16;
  }

  function setBusy(on) {
    var main = grid();
    if (!main) return;
    main.classList.toggle("st-chips-loading", on);
    if (on) main.setAttribute("aria-busy", "true");
    else main.removeAttribute("aria-busy");
  }

  function logFallback(reason, url) {
    var entry = { reason: reason, url: url, time: Date.now() };
    fallbacks.push(entry);
    try {
      var saved = JSON.parse(
        sessionStorage.getItem("stChipsFallbacks") || "[]",
      );
      saved.push(entry);
      sessionStorage.setItem(
        "stChipsFallbacks",
        JSON.stringify(saved.slice(-50)),
      );
    } catch (e) {
      /* storage blocked */
    }
    if (window.console && console.warn)
      console.warn(
        "[st-chips] page load instead of in-place switch:",
        reason,
        url,
      );
    if (Array.isArray(window.dataLayer))
      window.dataLayer.push({
        event: "st_chip_fallback",
        st_fallback_reason: reason,
        page_path: pageKey(url),
      });
  }

  // Sections other than grid and hero (banner, FAQ ...): after the swap, only those whose server HTML differs.
  function refreshOthers(from, to, top) {
    var list = others();
    var ids = list.map(sid);
    var chunks = [];
    for (var i = 0; i < ids.length; i += 5) chunks.push(ids.slice(i, i + 5));
    return Promise.all(
      chunks.map(function (chunk) {
        return Promise.all([sections(from, chunk), sections(to, chunk)]).catch(
          function () {
            return null;
          },
        );
      }),
    ).then(function (results) {
      if (pageKey(current) !== pageKey(to)) return;
      var loaded = loadedScripts();
      var changed = false;
      results.forEach(function (pair, n) {
        if (!pair) return;
        chunks[n].forEach(function (id) {
          var prev = document.getElementById("shopify-section-" + id);
          var before = parse(pair[0][id], id);
          var after = parse(pair[1][id], id);
          if (!prev || !after) return;
          if (
            before &&
            fingerprint(before, false) === fingerprint(after, false)
          )
            return;
          swapSection(prev, after, loaded);
          changed = true;
        });
      });
      if (changed) anchor(top);
    });
  }

  function go(url, push) {
    var target = new URL(url, location.href);
    var ids = mainIds();
    var me = {};
    job = me;
    var from = current;
    if (!ids) {
      logFallback("no-grid", target.href);
      window.location.assign(target.href);
      return Promise.resolve();
    }
    setBusy(true);
    var row = document.querySelector("#MainContent .st-chips");
    var rowLeft = row ? row.scrollLeft : 0;
    var group = row ? row.dataset.stGroup : "";

    var timer;
    var timeout = new Promise(function (resolve, reject) {
      timer = setTimeout(function () {
        reject(failure("timeout"));
      }, TIMEOUT);
    });
    var heroBefore = ids[1]
      ? sections(from, [ids[1]]).catch(function () {
          return {};
        })
      : Promise.resolve({});

    return Promise.race([
      Promise.all([sections(target.href, ids), heroBefore]),
      timeout,
    ])
      .then(function (res) {
        clearTimeout(timer);
        if (job !== me) throw failure("superseded");
        var json = res[0];
        var main = grid();
        var fresh = parse(json[ids[0]], ids[0]);
        // Another template (e.g. Sale) has other section ids: Shopify answers null for them.
        if (!main || !fresh || !fresh.querySelector("#ProductGridContainer"))
          throw failure("template");
        var head = ids[1]
          ? document.getElementById("shopify-section-" + ids[1])
          : null;
        var headFresh = ids[1] ? parse(json[ids[1]], ids[1]) : null;
        var headBefore = ids[1] ? parse(res[1][ids[1]], ids[1]) : null;

        var box = document.createElement("div");
        box.innerHTML = fresh.innerHTML;
        var waits = keepStyles(box, main).concat(preloadCards(box));

        return whenDone(waits, IMAGE_WAIT).then(function () {
          if (job !== me) throw failure("superseded");
          var top = rowTop();
          var loaded = loadedScripts();

          // One step, before the next paint: grid section, then the hero text.
          main.className = fresh.className;
          main.replaceChildren.apply(
            main,
            Array.prototype.slice.call(box.childNodes),
          );
          runScripts(main, loaded);
          var heroMode =
            head && headFresh
              ? updateHero(head, headFresh, headBefore, loaded)
              : "none";
          setBusy(true);
          syncHead(main, target.href);

          if (push) {
            history.replaceState(
              Object.assign({}, history.state, { stChips: true }),
              "",
              location.href,
            );
            history.pushState(
              { stChips: true },
              "",
              target.pathname + target.search + target.hash,
            );
            pushed = true;
            if ("scrollRestoration" in history)
              history.scrollRestoration = "manual";
          }
          current = target.pathname + target.search;
          anchor(top);
          keepRowScroll(rowLeft, group);

          var settle = [];
          document.dispatchEvent(new CustomEvent("collection:reloaded"));
          document.dispatchEvent(
            new CustomEvent("st:chips:navigate", {
              detail: {
                url: current,
                hero: heroMode,
                waitUntil: function (p) {
                  settle.push(p);
                },
              },
            }),
          );
          if (Array.isArray(window.dataLayer))
            window.dataLayer.push({
              event: "st_chip_navigation",
              page_path: current,
              page_title: document.title,
            });

          return whenDone(settle, SETTLE_WAIT).then(function () {
            if (job !== me) return;
            setBusy(false);
            anchor(top);
            // After the next layout (sections with content-visibility settle a frame later).
            requestAnimationFrame(function () {
              requestAnimationFrame(function () {
                anchor(top);
              });
            });
            return refreshOthers(from, target.href, top);
          });
        });
      })
      .catch(function (err) {
        clearTimeout(timer);
        var reason = (err && err.reason) || "error";
        if (reason === "superseded" || job !== me) return;
        setBusy(false);
        if (window.console && console.error && !err.reason) console.error(err);
        logFallback(reason, target.href);
        window.location.assign(target.href);
      });
  }

  window.stChipsNav = {
    go: go,
    prefetch: prefetch,
    fallbacks: fallbacks,
  };

  // assets/st-category-chips.js (PR #219) receives the taps when it is loaded (see header).
  function handledElsewhere() {
    return window.stCategoryChips;
  }

  function chipOf(event) {
    var link =
      event.target.closest &&
      event.target.closest(
        ".st-chips a.st-chip[href], .st-chips-sub a.st-subchip[href], .st-chips-types a.st-typechip[href]",
      );
    if (!link || !link.closest("#MainContent")) return null;
    var url = new URL(link.href, location.href);
    if (url.origin !== location.origin || !/\/collections\//.test(url.pathname))
      return null;
    if (
      (link.target && link.target !== "_self") ||
      link.hasAttribute("download")
    )
      return null;
    return link;
  }

  document.addEventListener("click", function (event) {
    var chip = chipOf(event);
    if (!chip) return;
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey)
      return;
    if (window.Shopify && window.Shopify.designMode) return;
    if (handledElsewhere()) return;

    var target = new URL(chip.href, location.href);
    event.preventDefault();
    if (target.pathname + target.search === current) return;

    // Sub-type tabs (Wrike 4586486589, round 11) are single-select like the chips: exactly one active.
    var row = chip.closest(".st-chips, .st-chips-sub, .st-chips-types");
    row.querySelectorAll(".st-chip, .st-subchip").forEach(function (el) {
      el.classList.toggle("is-active", el === chip);
      if (el === chip) el.setAttribute("aria-current", "page");
      else el.removeAttribute("aria-current");
    });
    go(target.href, true);
  });

  // Filters and sorting replace the URL in place (collection.js); keep "current" in step.
  document.addEventListener("collection:reloaded", function () {
    current = location.pathname + location.search;
  });

  // Sub-type tabs (Wrike 4586486589, rounds 9 and 11) sit outside the parts collection.js re-renders after a filter
  // change or a pill removal; take them from the same response so they never show a stale selection.
  function syncTypes(event) {
    var parsed =
      event &&
      (event.parsedHTML ||
        (event.responseText &&
          new DOMParser().parseFromString(event.responseText, "text/html")));
    if (!parsed) return;
    // Round 12: level 2 and level 3 come as one block inside the sticky bar.
    var fresh = parsed.querySelector(".st-chips-tiers");
    var old = document.querySelector("#MainContent .st-chips-tiers");
    var bar = document.querySelector(
      "#MainContent .collection__topbar--st-seg .facet-topbar",
    );
    if (old && fresh) old.replaceWith(document.importNode(fresh, true));
    else if (old) old.remove();
    else if (fresh && bar) bar.append(document.importNode(fresh, true));
    stuckBar.reset();
  }
  function subscribeTypes() {
    var pubsub = window.theme && window.theme.pubsub;
    if (pubsub && pubsub.subscribe && pubsub.PUB_SUB_EVENTS)
      pubsub.subscribe(pubsub.PUB_SUB_EVENTS.facetUpdate, syncTypes);
  }
  if (document.readyState === "loading")
    document.addEventListener("DOMContentLoaded", subscribeTypes);
  else subscribeTypes();

  // Warm the cache while the finger or the mouse is on the chip (not for chips that only open a row).
  ["touchstart", "pointerover", "focusin"].forEach(function (type) {
    document.addEventListener(
      type,
      function (event) {
        var chip = chipOf(event);
        if (chip && !chip.dataset.stSub) prefetch(chip.href);
      },
      { passive: true },
    );
  });

  // Round 12 (Wrike 4586486589, Ali 23.10.2026): sticky state of the Sale segment bar. While it sticks it carries
  // is-stuck (assets/st-category-chips.css). The rows it shrinks are given back as bottom margin, so the grid below
  // does not jump. The bar sticks when its top reaches its CSS top (below the header, 0 while the header is hidden);
  // its own height does not change that point.
  // Round 15 (Ali 23.10.2026 21:13): the whole block stays in the sticky bar (tabs, level 2, level 3, compact); the
  // path line and the overlay of round 14 are gone. Without the menu filter, the active level-3 chip comes from the URL
  // (data-st-url, snippets/st-chip-types.liquid) and, while the tab fits on one page (data-st-local), the cards without
  // that value are hidden here (data-st-menu-chips on the cards, sections/main-collection.liquid). Once the filter
  // exists, the server filters and the snippet drops both attributes.
  var stuckBar = (function () {
    var ticking = false;
    function bar() {
      return document.querySelector("#MainContent .collection__topbar--st-seg");
    }
    function set(el, on) {
      el.style.marginBlockEnd = "";
      el.classList.remove("is-stuck");
      if (!on) return;
      // The block below (its top) must not move. Measured, not computed: the margin can collapse with the next
      // block's own margin (from 1280 px).
      var next = el.nextElementSibling;
      while (next && !next.getClientRects().length)
        next = next.nextElementSibling;
      var before = next ? next.getBoundingClientRect().top : 0;
      el.classList.add("is-stuck");
      if (!next) return;
      var base = parseFloat(getComputedStyle(el).marginBlockEnd) || 0;
      for (var i = 0; i < 3; i++) {
        var gap = before - next.getBoundingClientRect().top;
        if (Math.abs(gap) < 0.5) break;
        base = Math.max(0, base + gap);
        el.style.marginBlockEnd = base + "px";
      }
    }
    function check() {
      ticking = false;
      var el = bar();
      if (!el) return;
      var top = parseFloat(getComputedStyle(el).top) || 0;
      var on = window.scrollY > 0 && el.getBoundingClientRect().top <= top + 2;
      if (on !== el.classList.contains("is-stuck")) set(el, on);
    }
    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(check);
    }
    // The active tab of every row in view (also in the compact sticky rows).
    function reveal() {
      document
        .querySelectorAll(
          "#MainContent .st-chips-types .is-active, #MainContent .st-chips--seg .is-active",
        )
        .forEach(function (chip) {
          var row = chip.parentElement;
          // Desktop (round 14): level 2 | level 3 swipe together in .st-chips-tiers.
          if (
            row.scrollWidth <= row.clientWidth &&
            row.parentElement.classList.contains("st-chips-tiers")
          )
            row = row.parentElement;
          var a = chip.getBoundingClientRect();
          var r = row.getBoundingClientRect();
          if (!r.width) return;
          if (a.left < r.left) row.scrollLeft += a.left - r.left - 16;
          else if (a.right > r.right) row.scrollLeft += a.right - r.right + 16;
        });
    }
    // Level 3 without the menu filter: Shopify ignores the param, so the server can neither mark the chip nor narrow
    // the grid.
    function urlLevel3(el) {
      el.querySelectorAll(".st-chips-types--l3[data-st-url]").forEach(
        function (nav) {
          var picked = new URLSearchParams(location.search).getAll(
            nav.dataset.stUrl,
          );
          var chips = nav.querySelectorAll(".st-typechip");
          var hit = null;
          chips.forEach(function (chip) {
            if (picked.length === 1 && chip.dataset.stValue === picked[0])
              hit = chip;
          });
          chips.forEach(function (chip, i) {
            var on = hit ? chip === hit : i === 0;
            chip.classList.toggle("is-active", on);
            if (on) chip.setAttribute("aria-current", "page");
            else chip.removeAttribute("aria-current");
          });
          nav.classList.toggle("st-chips-types--picked", !!hit);
          filterLevel3(nav.hasAttribute("data-st-local") && hit);
        },
      );
    }
    // Round 15: hide the cards without the picked level-3 value; the result counts follow the visible cards.
    function filterLevel3(hit) {
      var box = document.getElementById("ProductGridContainer");
      if (!box) return;
      var value = hit ? hit.dataset.stValue : "";
      var shown = 0;
      box.querySelectorAll("[data-st-menu-chips]").forEach(function (card) {
        var out =
          !!value &&
          card.dataset.stMenuChips.split("|").indexOf(value) === -1;
        card.classList.toggle("st-l3-out", out);
        if (!out) shown++;
      });
      var main = grid();
      if (!main) return;
      main.querySelectorAll("results-count").forEach(function (count) {
        if (!count.hasAttribute("data-st-total"))
          count.setAttribute("data-st-total", count.textContent.trim());
        count.textContent = value ? shown : count.getAttribute("data-st-total");
      });
    }
    function reset() {
      var el = bar();
      if (el) urlLevel3(el);
      if (el && el.classList.contains("is-stuck")) set(el, true);
      check();
      reveal();
    }
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    document.addEventListener("st:chips:navigate", reset);
    // Filters and sorting (collection.js) re-render the grid: hide the cards again.
    document.addEventListener("collection:reloaded", reset);
    if (document.readyState === "loading")
      document.addEventListener("DOMContentLoaded", reset);
    else reset();
    return { reset: reset };
  })();

  window.addEventListener("popstate", function () {
    if (!pushed) return;
    if (location.pathname + location.search === current) return;
    go(location.href, false);
  });
})();
